// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ItalicOutlinedSvg from "@fishx/icons-svg/es/asn/ItalicOutlined";
import FishxIcon from '../components/FishxIcon';

var ItalicOutlined = function ItalicOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ItalicOutlinedSvg
  }));
};

ItalicOutlined.displayName = 'ItalicOutlined';
export default React.forwardRef(ItalicOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ItalicOutlined.js
// module id = 3004
// module chunks = 0